import { createContext } from "react";

export const TabContext = createContext({});
export const NotificationTabContext = createContext({});
